(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bc-load-more')) {
    customElements.define('bc-load-more', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-bc-more]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          event.stopPropagation();
          if (!this.busy) this.load(link, event.detail === 0);
        });
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }

      async load(link, keyboard) {
        const section = this.closest('[data-section-type="collection-template"]');
        const grid = section && section.querySelector('[data-bc-product-grid]');
        if (!grid) { location.assign(link.href); return; }
        const context = location.href;
        const url = new URL(link.href, location.origin);
        const current = new URL(context);
        for (const key of new Set(current.searchParams.keys())) {
          if (key === 'sort_by' || key.startsWith('filter.') || key === 'preview_theme_id') {
            url.searchParams.delete(key);
            current.searchParams.getAll(key).forEach(value => url.searchParams.append(key, value));
          }
        }
        url.searchParams.delete('view');
        url.searchParams.set('section_id', this.dataset.sectionId);
        this.busy = true;
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 20000);
        const status = this.querySelector('[data-bc-status]');
        const fallback = this.querySelector('[data-bc-fallback]');
        status.textContent = '';
        status.removeAttribute('data-error');
        fallback.hidden = true;
        link.setAttribute('aria-disabled', 'true');
        link.textContent = this.dataset.loading;
        grid.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(url.href, {credentials:'same-origin', signal:this.controller.signal});
          if (!response.ok) throw new Error('collection_response');
          const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextSection = documentNext.querySelector('[data-section-type="collection-template"]');
          const nextGrid = nextSection && nextSection.querySelector('[data-bc-product-grid]');
          const nextControl = nextSection && nextSection.querySelector('bc-load-more');
          const products = nextGrid ? Array.from(nextGrid.children).filter(item => item.classList.contains('grid-product')) : [];
          if (!nextControl || !products.length || Number(nextControl.dataset.page) !== Number(this.dataset.page) + 1) throw new Error('collection_markup');
          if (!this.isConnected || location.href !== context) return;
          const firstLink = products[0].querySelector('.grid-product__link');
          grid.append(...products);
          nextSection.querySelectorAll('.modal--quick-shop').forEach(modal => {
            if (!document.getElementById(modal.id)) section.append(modal);
          });
          this.dataset.page = nextControl.dataset.page;
          this.querySelector('progress').value = nextControl.querySelector('progress').value;
          const nextLink = nextControl.querySelector('[data-bc-more]');
          if (nextLink) {
            link.href = nextLink.href;
            fallback.href = nextLink.href;
            status.textContent = this.dataset.loaded;
          } else {
            link.hidden = true;
            this.querySelector('[data-bc-complete]').hidden = false;
            status.textContent = this.querySelector('[data-bc-complete]').textContent;
          }
          try {
            if (window.theme && typeof window.theme.reinitProductGridItem === 'function') window.theme.reinitProductGridItem(window.jQuery ? window.jQuery(section) : undefined);
          } catch (error) {
            products.forEach(product => product.classList.add('aos-animate'));
          }
          products.forEach(product => product.classList.add('aos-animate'));
          if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
          products.forEach(product => {
            product.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
              const image = product.querySelector('.grid-product__color-image--' + swatch.dataset.variantId);
              if (!image) return;
              swatch.addEventListener('mouseenter', () => {
                image.style.backgroundImage = 'url("' + swatch.dataset.variantImage + '")';
                image.classList.add('is-active');
              });
              swatch.addEventListener('mouseleave', () => image.classList.remove('is-active'));
            });
          });
          if (keyboard && firstLink) firstLink.focus({preventScroll:true});
          this.dispatchEvent(new CustomEvent('bc:products-loaded', {bubbles:true}));
        } catch (error) {
          if (this.isConnected && location.href === context) {
            status.dataset.error = 'true';
            status.textContent = this.dataset.error;
            fallback.hidden = false;
          }
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          link.removeAttribute('aria-disabled');
          link.textContent = this.dataset.more;
          grid.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
